  <script>
	import { http } from 'plugins/http'
	export default {
		data() {
				return {
				  campaignUserRole: '',
				  user_permission:{
                        data: {
                        	campaign_view: '',
                        	campaign_create: '',
                        	campaign_schedule: '',
                        	announcement_view: '',
                        	announcement_create: '',
                        	view_recepients: '',
                        	add_new_recepients: '',
                        	view_report: '',
                        	add_new_report: '',
                        	domain: '',
                        	general: '',
                        	user_management: '',
                        	retest_frequency: '',
                        	direct_learning_management: '',
                        	direct_learning_invitation_mail: '',
                        	direct_learning_login_mail: '',
                        	direct_learning_with_username_and_password_mail: '',
                        	landing_oops: '',
                        	training_mail: '',
                        	email_setting: '',
                        	company_logo: {
                        		logo: '',
                        	}
                        },
                    },
	 	}
	},
	computed: {
		// campaign_user_roles.role_type — 'creator' | 'approver' | 'both'.
		// Approvers (and 'both') get the Approvers Workspace; creators get theirs.
		canApproveWorkspace() {
			return this.campaignUserRole === 'approver' || this.campaignUserRole === 'both'
		},
		canCreateWorkspace() {
			return this.campaignUserRole === 'creator' || this.campaignUserRole === 'both'
		}
	},
	created() {
		// Always resolve the CURRENT user's role from the API — never trust the
		// per-origin localStorage cache. It previously held a *different* user's
		// role after another user signed in on the same browser (e.g. an approver's
		// cached role shown to a creator), because this hook only fetched when the
		// cache was empty. We leave campaignUserRole as '' until the fresh answer
		// arrives so no workspace link flashes for the wrong role.
		http.get('setting/user-role-name').then((response) => {
			const roleName = (response.data && response.data.role_name) ? response.data.role_name : ''
			this.campaignUserRole = roleName
			localStorage.setItem('campaignUserRole', roleName)
		}).catch(() => {
			// Keep any cached value on network error so the menu still renders.
			this.campaignUserRole = localStorage.getItem('campaignUserRole') || ''
		})
	},
 }
</script>
<template>
   <!-- side nav bar -->
  <nav class="page-sidebar" data-pages="sidebar">
     <div class="sidebar-menu">
        <ul class="menu-items">
           <li class="open active padtopbottom">
             <div class="lmsSidebarHeader">
              <span class="title">LMS</span>
                  <!-- <div class="sidebarCollapse">
                     <img src="../../../static/img/sidebar-collapse.svg" alt="icon">
                  </div> -->
                  <div aria-label="Pin Menu" type="button"  class="sidebarCollapse"><i class="pg-icon"></i></div>
               </div>
              <ul class="sub-menu">
                 <li class="hide_after_click">
                     <router-link :to="{ name: 'lms.courses'}">Courses</router-link>
                     <span class="icon-thumbnail"><i class="fas fa-book"></i></span>
                 </li>
                 <li class="hide_after_click">
                  <router-link :to="{ name: 'lms.reports'}">Reports</router-link>
                  <span class="icon-thumbnail"><i class="fas fa-file-alt"></i></span>
                 </li>

                 <li class="hide_after_click">
                  <router-link :to="{ name: 'lms.setting'}">Settings</router-link>
                   <span class="icon-thumbnail"><i class="fas fa-cog"></i></span>
                 </li>
                 <li class="hide_after_click">
                  <router-link :to="{ name: 'lms.emaillogs'}">Logs</router-link>
                      <span class="icon-thumbnail"><i class="fas fa-clipboard-list"></i></span>
                 </li>
                 <li class="hide_after_click">
                  <router-link :to="{ name: 'lms.learningpath'}">Learning Path</router-link>
                      <span class="icon-thumbnail"> <i class="fa fa-user-graduate"></i></span>
                 </li>
                 <li class="hide_after_click" v-if="canApproveWorkspace">
                  <router-link :to="{ name: 'lms.approvals'}">Approvers Workspace</router-link>
                      <span class="icon-thumbnail"><i class="fas fa-clipboard-check"></i></span>
                 </li>
                 <li class="hide_after_click" v-if="canCreateWorkspace">
                  <router-link :to="{ name: 'lms.creatorapprovals'}">Creators Workspace</router-link>
                      <span class="icon-thumbnail"><i class="fas fa-user-edit"></i></span>
                 </li>
              </ul>
           </li>
        </ul>
     </div>
  </nav>
</template>





// WEBPACK FOOTER //
// sidebar.vue?4c751d88